"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBlock = exports.NowNodes = void 0;
const nownodes_1 = __importDefault(require("./nownodes"));
exports.NowNodes = nownodes_1.default;
const getblock_1 = __importDefault(require("./getblock"));
exports.GetBlock = getblock_1.default;
//# sourceMappingURL=index.js.map